import { inject, Injectable, OnInit ,signal} from "@angular/core";
import { ApiService } from "../core/api.service";
import { ActivatedRoute } from "@angular/router";

export type typeAction = 'create' | 'edit' | 'delete' | 'view';
@Injectable({
  providedIn: 'any'
})
export abstract class BaseCrud<T> implements OnInit{
  abstract type : typeAction
  abstract apiService:ApiService<T>
  dataForm!: any;
  id!:number;
  dataFetch!:any;
  private activatedRoute = inject(ActivatedRoute);
  constructor() {
      // Access route parameters
      this.activatedRoute.params.subscribe((params) => {
        this.id = params['id'];
      });
    }
  ngOnInit(): void {
    switch (this.type) {
      case 'view':
        this.apiService.getById(this.id).subscribe((data)=>{
          this.dataFetch = data
        });
        break;
      case 'delete':
        // this.data = this.apiService.delete(this.id);
        break;

      default:
        break;
    }
  }
}
